import {connect} from "react-redux";
import PostClosure from "./save";
import {bindActionCreators} from "redux";
import {savePostClosure} from "../../../service/Activity/action";
import {documentUploadUrlPublic} from "../../../service/fileUpload/action";
import {accountDetailsById} from "../../../service/Account/action";

const mapStateToProps = (state) => ({
    postClosureDetails:state.Activity.postClosureDetails,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    accountDetails:state.Dropdown.accountDetailsById,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            savePostClosure,
            documentUploadUrlPublic,
            accountDetailsById
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(PostClosure);
